import CryptoJS from 'crypto-js';

const secretKey = process.env.NEXT_PUBLIC_CRYPTO_KEY!;

const encrypt = (value: string): string => {
	const ciphertext = CryptoJS.AES.encrypt(value, secretKey);
	const base64Encoded = CryptoJS.enc.Base64.stringify(
		CryptoJS.enc.Utf8.parse(ciphertext.toString())
	);
	return base64Encoded;
};

const decrypt = (value: string): string | null => {
	try {
		const base64Decoded = CryptoJS.enc.Utf8.stringify(
			CryptoJS.enc.Base64.parse(decodeURIComponent(value))
		);
		const bytes = CryptoJS.AES.decrypt(base64Decoded, secretKey);
		return bytes.toString(CryptoJS.enc.Utf8);
	} catch (error) {
		return null;
	}
};

export { encrypt, decrypt };
